<template>
  <div>
    <v-select
      v-model="selectedCourse"
      :items="courses"
      item-text="courseName"
      item-value="id"
      outlined
      label="Kopiera till yrkeskurs"
      return-object
    >
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title>{{ data.item.courseName }}</v-list-item-title>
          <v-list-item-subtitle>{{ data.item.groupName }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-select>
  </div>
</template>

<script>
import API from '@/services/api'
import sortBy from 'lodash/sortBy'

export default {
  name: 'TheCopyPasteCourseSelect',

  props: {
    professionId: {
      type: Number,
      required: true
    },

    professionCourse: {
      type: Object,
      default: () => ({})
    },

    reform: {
      type: String,
      default: ''
    },

    practicalCourses: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    courses: []
  }),

  computed: {
    selectedCourse: {
      get() {
        return this.professionCourse
      },
      set(value) {
        this.$emit('selected-course', value)
      }
    }
  },

  watch: {
    reform: {
      handler(newValue) {
        this.fetchCourses(this.professionId, newValue)
      },
      immediate: true
    },
    
    professionId: {
      handler(newValue) {
        this.fetchCourses(newValue, this.reform)
      }
    },

    selectedCourse: {
      handler(newValue) {
        this.$emit('selected-course', newValue)
      },
      immediate: true
    }
  },

  methods: {
    fetchCourses(professionId, reform = null) {
      if (!professionId) return
      this.selectedCourse = null

      API.listPlainProfessionCourses(professionId, { data: { reform } })
      .then(res => this.courses = sortBy(res.data, ['groupName', 'courseName']))
      .catch(error => console.log(error))
    },
  }
}
</script>

<style>

</style>